(function () {
  'use strict';
 
  document.addEventListener('DOMContentLoaded', init);
 
  function init() {
    var form = document.querySelector('.cart__container form[data-form]');
    if (!form) return; // empty cart, or a different cart template
 
    reorderGroups(form);
    disableAddonRemoval(form);
    interceptRemoveLinks(form);
    interceptFormSubmit(form);
  }
 
  function getItems(form) {
    return Array.prototype.slice.call(form.querySelectorAll('.cart__item[data-item-key]'));
  }
 
  function isMainItem(el) {
    return !!el.dataset.orderGroup && !el.dataset.programFor;
  }
 
  function isAddonItem(el) {
    return !!el.dataset.orderGroup && !!el.dataset.programFor;
  }
 
  function hasMainItem(items, orderGroup) {
    return items.some(function (el) { return isMainItem(el) && el.dataset.orderGroup === orderGroup; });
  }
 
  function groupMates(items, orderGroup, exceptKey) {
    return items.filter(function (el) {
      return el.dataset.orderGroup === orderGroup && el.dataset.itemKey !== exceptKey;
    });
  }
 
  // --- 1. Visual reordering ---
  function reorderGroups(form) {
    var items = getItems(form);
 
    items.forEach(function (el) {
      var group = el.dataset.orderGroup;
      if (!isAddonItem(el)) return;
      if (!hasMainItem(items, group)) return; // orphaned — leave it wherever it naturally sits
 
      var mainEl = items.filter(function (m) { return m.dataset.orderGroup === group && isMainItem(m); })[0];
      if (mainEl && mainEl.nextSibling !== el) {
        mainEl.parentNode.insertBefore(el, mainEl.nextSibling);
      }
    });
  }
 
  // --- 0. Disable removing a (non-orphaned) addon item on its own ---
  function disableAddonRemoval(form) {
    var items = getItems(form);
 
    items.forEach(function (el) {
      if (!isAddonItem(el)) return;
      if (!hasMainItem(items, el.dataset.orderGroup)) return; // orphaned — leave fully removable
 
      var removeLink = el.querySelector('.cart-item__remove');
      if (removeLink) removeLink.remove();
 
      var qtySelector = el.querySelector('.cart__item-qty-selector');
      if (qtySelector) qtySelector.style.display = 'none';
 
      var input = el.querySelector('[data-quantity-input]');
      if (input) {
        input.min = '1';
        input.addEventListener('input', function () {
          if (parseInt(input.value, 10) < 1 || input.value === '') {
            input.value = 1;
          }
        });
      }
    });
  }
 
  // --- 2. Cascade removal via the "Remove" link ---
  function interceptRemoveLinks(form) {
    form.addEventListener('click', function (e) {
      var link = e.target.closest('.cart-item__remove');
      if (!link) return;
 
      var itemEl = link.closest('.cart__item[data-item-key]');
      if (!itemEl) return; // not one of our rows; let default behavior run
 
      e.preventDefault();
      e.stopPropagation();
 
      var items = getItems(form);
      var updates = {};
      updates[itemEl.dataset.itemKey] = 0;
 
      if (isMainItem(itemEl)) {
        groupMates(items, itemEl.dataset.orderGroup, itemEl.dataset.itemKey).forEach(function (mate) {
          updates[mate.dataset.itemKey] = 0;
        });
      }
 
      submitUpdates(updates, link);
    }, true);
  }
 
  // --- 3. Cascade removal via quantity-to-0 + the "Update" button ---
  function interceptFormSubmit(form) {
    form.addEventListener('submit', function (e) {
      var items = getItems(form);
 
      // Safety net: a non-orphaned addon's quantity should never reach
      // 0 on its own — if it somehow did, force it back to 1 before
      // submission rather than let a standalone addon removal slip
      // through. Orphaned addons are exempt — they're allowed to be
      // zeroed/removed normally.
      items.forEach(function (el) {
        if (!isAddonItem(el)) return;
        if (!hasMainItem(items, el.dataset.orderGroup)) return; // orphaned — allow normal removal
        var input = el.querySelector('[data-quantity-input]');
        if (input && (parseInt(input.value, 10) < 1 || input.value === '')) {
          input.value = 1;
        }
      });
 
      var updateBtn = document.activeElement;
      var isUpdateSubmit = updateBtn && updateBtn.name === 'update';
      if (!isUpdateSubmit) return; // checkout submit, or something else — leave alone
 
      var zeroedMainGroups = [];
 
      items.forEach(function (el) {
        if (!isMainItem(el)) return;
        var input = el.querySelector('[data-quantity-input]');
        if (input && parseInt(input.value, 10) === 0) {
          zeroedMainGroups.push(el.dataset.orderGroup);
        }
      });
 
      if (!zeroedMainGroups.length) return; // nothing to cascade — let the normal submit proceed
 
      // Before the normal form submission proceeds, also zero every
      // addon's own quantity input for any group whose main item is
      // being set to 0 — so the single native submit (whether this
      // theme's own AJAX cart handles it, or it's a full page post)
      // naturally includes the cascade with no extra request needed.
      items.forEach(function (el) {
        if (isMainItem(el)) return;
        if (zeroedMainGroups.indexOf(el.dataset.orderGroup) === -1) return;
        var input = el.querySelector('[data-quantity-input]');
        if (input) input.value = 0;
      });
      // Submission proceeds normally from here — nothing to prevent.
    }, true);
  }
 
  function submitUpdates(updates, triggerLink) {
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
 
    if (triggerLink) {
      triggerLink.textContent = '...';
      triggerLink.style.pointerEvents = 'none';
    }
 
    fetch(rootUrl + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        window.location.reload();
      })
      .catch(function (err) {
        console.error('cart-order-groups: /cart/update.js failed', err);
        window.alert('Something went wrong updating your cart. Please refresh and try again.');
        if (triggerLink) {
          triggerLink.textContent = 'Remove';
          triggerLink.style.pointerEvents = '';
        }
      });
  }
})();